// extracted by mini-css-extract-plugin
module.exports = {"teamList":"style_teamList__G4wNF","seriesName":"style_seriesName__W3qMU"};